__turbopack_context__.v({
  "baseButton": "CTAButtons-module__n68p_q__baseButton",
  "buttonsRow": "CTAButtons-module__n68p_q__buttonsRow",
  "primaryButton": "CTAButtons-module__n68p_q__primaryButton",
  "secondaryButton": "CTAButtons-module__n68p_q__secondaryButton",
});
